import { CommonModule } from '@angular/common';
import { Component, computed } from '@angular/core';
import { RouterLink } from '@angular/router';
import { Icon, ModalBasement, ModalContainer } from '@millionshow/client-libs';

interface ApplicationCompleteModalProps {
  eventTitle: string;
  companyName: string;
  managerName: string;
  managerPhone: string;
}

@Component({
  selector: 'app-application-complete-modal',
  templateUrl: './application-complete.modal.html',
  imports: [CommonModule, ModalContainer, Icon, RouterLink],
})
export class ApplicationCompleteModal extends ModalBasement<ApplicationCompleteModalProps> {
  eventTitle = computed(() => this.props()?.eventTitle || '');
  companyName = computed(() => this.props()?.companyName || '');
  managerName = computed(() => this.props()?.managerName || '');
  managerPhone = computed(() => this.props()?.managerPhone || '');
}
